import { render, staticRenderFns } from "./form-checkbox.vue?vue&type=template&id=f79df514&scoped=true&"
import script from "./form-checkbox.vue?vue&type=script&lang=js&"
export * from "./form-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./form-checkbox.vue?vue&type=style&index=0&id=f79df514&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79df514",
  null
  
)

export default component.exports